// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__6WjJd","topBottomGutter":"Layout_topBottomGutter__1SEy2"};